<div>
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
    <div class="loading-text">Signing you in…</div>
  </div>
  <div class="outer-container">
    <div class="login-img">
      <img src="/assets/wg-learning-center-hero.svg" alt="Learning Center Illustration">
    </div>

    <div class="form-container">
      <div class="logo-img" aria-label="WGINB Learning Center">
        <img src="/assets/white_theme_without_background.png" alt="WGINB Learning Center Logo">
      </div>
      <button pButton
        id="login-btn"
        type="button"
        label="LOGIN USING SSO"
        (click)="onLogin()">
      </button>
      <div *ngIf="errorText" class="error-message" role="alert" aria-live="assertive">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
        <span>{{ errorText }}</span>
      </div>
    </div>
  </div>
</div>

